// utils/linkifyKeywords.js

export const linkifyKeywords = (text, keywordLinks) => {
    const escapedKeywords = Object.keys(keywordLinks)
      .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")); // Escape special regex chars
  
    const regex = new RegExp(`\\b(${escapedKeywords.join("|")})\\b`, "gi");
  
    return text.replace(regex, (matched) => {
      const key = Object.keys(keywordLinks).find(
        (k) => k.toLowerCase() === matched.toLowerCase()
      );
      if (key) {
        return `<a href="${keywordLinks[key]}" class="text-blue-600 underline" target="_blank" rel="noopener noreferrer">${matched}</a>`;
      }
      return matched;
    });
  };
  